import React from 'react';
import { Container } from 'components/styled/ui';
import { images } from 'config';
import styled from 'styled-components';
import { media } from 'components/styled/utils';

const Logo = ({ children }) => (
  <Content className="banner" background={images.banner}>
    <Container>{children}</Container>
  </Content>
);

export default Logo;

const Content = styled.div`
  background: url('${props => props.background}') no-repeat fixed 0 0 /
    cover;
    padding: 108px 0 36px 0;
    position: relative;
    background-image: linear-gradient(142deg, rgba(1,107,194,0.91) 0%, #00766F 100%, rgba(0,110,97,0.49) 100%);

    ${media.sm`
    padding: 134px 0 47px 0
    `}
    
    &:before{
        content: '';
        position: absolute;
        opacity: 0.05;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url('${props => props.background}') no-repeat fixed 0 0 /cover;
    }

    >div{
        position: relative;
    }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/banner/banner.js